<div
  matAutocompleteOrigin
  #origin="matAutocompleteOrigin"
  (click)="mainInput.focus()"
  style="overflow: visible"
  >
  <mat-card
    style="display: flex; flex-direction: row"
    class="header-container"
    [ngClass]="
      trigger.panelOpen
        ? 'header-container--no-radius cis-shadow'
        : 'header-container--radius'
    "
    attr.data-testid="cis_page_{{
      title.toLowerCase().replace(' ', '_')
    }}_field"
    >
    <div class="left-container d-none d-md-flex" style="overflow: hidden">
      @if (loading) {
        <mat-progress-spinner
          class="search-spinner"
          color="accent"
          mode="indeterminate"
          [diameter]="30"
        attr.data-testid="cis_page_{{
          title.toLowerCase().replace(' ', '_')
        }}_progress_indicator"
          >
        </mat-progress-spinner>
      }
      <button
        [color]="config.searchButtonColor"
        [matTooltip]="config.clearButtonTooltip ?? ''"
        class=""
        mat-icon-button
        [ngClass]="
          !loading &&
          (closeButtonAvailable ||
            selectedChips.length ||
            chipCtrl.value?.length)
            ? 'slide-in-left'
            : 'slide-out-left'
        "
        (click)="$event.stopPropagation(); trigger.closePanel(); reset()"
        attr.data-testid="cis_page_{{
          title.toLowerCase().replace(' ', '_')
        }}_btn_close_panel"
        >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div
      class="wrapper"
      [ngClass]="
        loading ||
        closeButtonAvailable ||
        selectedChips.length ||
        chipCtrl.value?.length
          ? 'wrapper--no-margin'
          : 'wrapper--left-margin'
      "
      >
      <div class="inner-container">
        <mat-chip-listbox
          hideSingleSelectionIndicator="true"
          attr.data-testid="cis_page_{{
            title.toLowerCase().replace(' ', '_')
          }}_chips_list"
          #chipList
          class="mr-2"
          >
          @for (selectedChip of selectedChips; track selectedChip) {
            <span
              class="my-0"
              style="margin-top: 6px !important"
              >
              @if (selectedChip.chipProperties.type === chipsTypes.TEXT) {
                <el-cis-text-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  >
                </el-cis-text-chip-search-filter>
              }
              @if (selectedChip.chipProperties.type === chipsTypes.DATE) {
                <cis-date-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  >
                </cis-date-chip-search-filter>
              }
              @if (selectedChip.chipProperties.type === chipsTypes.DATE_RANGE) {
                <el-cis-date-range-chip-search-filter
                  [labelSuffix]="config.dateRangeLabelSuffix ?? ''"
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  >
                </el-cis-date-range-chip-search-filter>
              }
              @if (selectedChip.chipProperties.type === chipsTypes.NUMBER) {
                <el-cis-number-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  >
                </el-cis-number-chip-search-filter>
              }
              @if (
                selectedChip.chipProperties.type === chipsTypes.NUMBER_RANGE
                ) {
                <el-cis-number-range-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  >
                </el-cis-number-range-chip-search-filter>
              }
              @if (selectedChip.chipProperties.type === chipsTypes.SLIDER) {
                <el-cis-slider-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  (isSliderOpen)="trigger.closePanel()"
                  >
                </el-cis-slider-chip-search-filter>
              }
              @if (
                selectedChip.chipProperties.type === chipsTypes.AUTOCOMPLETE
                ) {
                <el-cis-autocomplete-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  >
                </el-cis-autocomplete-chip-search-filter>
              }
              @if (selectedChip.chipProperties.type === chipsTypes.SELECT) {
                <el-cis-select-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                ></el-cis-select-chip-search-filter>
              }
              @if (
                selectedChip.chipProperties.type === chipsTypes.FILTER_SELECT
                ) {
                <el-cis-filter-select-chip-search-filter
                  [selectedData]="selectedChip"
                  (editedData)="editedSelectedChipsValues($event)"
                  (removeData)="remove($event)"
                  [loading]="loading"
                  >
                </el-cis-filter-select-chip-search-filter>
              }
            </span>
          }
        </mat-chip-listbox>
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="1"
          [readOnly]="loading"
          [style.cursor]="loading ? 'context-menu' : 'auto'"
          [placeholder]="getPlaceHolder()"
          #chipInput
          #mainInput
          (blur)="this.closeButtonAvailable = false"
          [formControl]="chipCtrl"
          [matAutocomplete]="auto"
          [matAutocompleteConnectedTo]="origin"
          #trigger="matAutocompleteTrigger"
          autocomplete="off"
          [value]="chipCtrl.value ?? ''"
          class="search-input"
          (focus)="trigger.openPanel()"
          attr.data-testid="cis_page_{{
            title.toLowerCase().replace(' ', '_')
          }}_text_area"
        ></textarea>
      </div>
      <div class="search-container">
        <button
          mat-flat-button
          color="accent"
          [matTooltip]="config.searchButtonText ?? ''"
          (click)="
            $event.stopPropagation(); trigger.closePanel(); onClickSearch()
          "
          attr.data-testid="cis_page_{{
            title.toLowerCase().replace(' ', '_')
          }}_btn_search"
          >
          {{ config.searchButtonText }}
        </button>
      </div>
    </div>
    <div class="right-container d-none d-md-flex">
      <button
        mat-icon-button
        [color]="config.searchButtonColor"
        [matTooltip]="config.expandTooltip ?? ''"
        (click)="$event.stopPropagation(); toggle(trigger)"
        attr.data-testid="cis_page_{{
          title.toLowerCase().replace(' ', '_')
        }}_btn_toggle_panel"
        >
        <mat-icon
          [ngClass]="trigger.panelOpen ? 'icon-expanded' : 'icon-collapsed'"
          attr.data-testid="cis_page_{{
            title.toLowerCase().replace(' ', '_')
          }}_icon_toggle_panel"
          >expand_more</mat-icon
          >
        </button>
      </div>
    </mat-card>

    <mat-autocomplete #auto="matAutocomplete" [disableRipple]="true">
      @for (section of (filteredSections | async) ?? []; track section; let i = $index) {
        <mat-option
          style="height: max-content; width: 100%; font-size: 14px"
      attr.data-testid="cis_page_{{
        title.toLowerCase().replace(' ', '_')
      }}_section_{{ section.section.toLowerCase().replace(' ', '_') }}"
          >
          <button mat-icon-button (click)="$event.stopPropagation()">
            @if (!panelClose[i]) {
              <mat-icon
                class="cis-section-header"
                style="margin-left: 0px"
                (click)="panelClose[i] = true"
          attr.data-testid="cis_page_{{
            title.toLowerCase().replace(' ', '_')
          }}_section_{{
            section.section.toLowerCase().replace(' ', '_')
          }}_btn_collapse"
                >expand_more
              </mat-icon>
            }
            @if (panelClose[i]) {
              <mat-icon
                class="cis-section-header"
                style="margin-left: 7px"
                (click)="this.panelClose[i] = false"
          attr.data-testid="cis_page_{{
            title.toLowerCase().replace(' ', '_')
          }}_section_{{
            section.section.toLowerCase().replace(' ', '_')
          }}_btn_expand"
                >chevron_right
              </mat-icon>
            }
          </button>
          <span
        attr.data-testid="cis_page_{{
          title.toLowerCase().replace(' ', '_')
        }}_section_{{ section.section.toLowerCase().replace(' ', '_') }}"
            class="cis-section-header"
            >{{ section.section }}</span
            >
            <mat-accordion>
              <div
                class="available-chip-container"
                style="margin-left: 34px !important; margin-bottom: 6px !important"
                >
                <mat-chip-listbox hideSingleSelectionIndicator="true">
                  @for (chip of section.filters; track chip) {
                    <mat-chip-option
                      style="cursor: pointer"
              (click)="
                $event.stopPropagation();
                chip.dependable
                  ? chip.dependableChipEnabled
                    ? selected(chip)
                    : ''
                  : selected(chip)
              "
              attr.data-testid="cis_page_{{
                title.toLowerCase().replace(' ', '_')
              }}_section_{{
                section.section.toLowerCase().replace(' ', '_')
              }}_chip_{{ chip.name.toLowerCase().replace(' ', '_') }}"
                      >
                      {{ chip.name | translate }}
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
              </div>
            </mat-accordion>
          </mat-option>
        }
      </mat-autocomplete>
    </div>
